import { defineSystem, EntityIndex, getComponentValueStrict, Has, Not, NotValue, UpdateType } from "@latticexyz/recs";
import { PhaserLayer } from "../../types";

export function createCycleUsableUnitsSystem(layer: PhaserLayer) {
  const {
    world,
    parentLayers: {
      network: {
        components: { Position, OwnedBy, Stamina },
        network: { connectedAddress },
      },
      headless: {
        components: { LocalStamina, OnCooldown },
        api: { getCurrentStamina, unitSort },
      },
    },
    scenes: {
      Main: { input },
    },
    api: { selectAndView },
  } = layer;

  let ownedUnitsWithStamina = new Set<EntityIndex>();
  let lastSelectedUnitIndex = -1;

  defineSystem(
    world,
    [Has(Position), Has(OwnedBy), Has(Stamina), Has(LocalStamina), Not(OnCooldown)],
    ({ entity, type }) => {
      if (type === UpdateType.Exit) {
        ownedUnitsWithStamina.delete(entity);
        return;
      }

      const currentStamina = getCurrentStamina(entity);
      if (currentStamina < 1_000) {
        ownedUnitsWithStamina.delete(entity);
        return;
      }

      const ownedBy = getComponentValueStrict(OwnedBy, entity).value;
      if (ownedBy === connectedAddress.get()) {
        ownedUnitsWithStamina.add(entity);
      }

      ownedUnitsWithStamina = new Set([...ownedUnitsWithStamina].sort(unitSort));
    }
  );

  input.onKeyPress(
    (keys) => keys.has("ENTER"),
    () => {
      lastSelectedUnitIndex++;
      const units = [...ownedUnitsWithStamina];
      if (lastSelectedUnitIndex >= units.length) lastSelectedUnitIndex = 0;
      const unit = units[lastSelectedUnitIndex];
      selectAndView(unit);
    }
  );
}
